/**
 * The answer key of a lights out is a press sequence. Kept apart from the form component so
 * the eagerly loaded module file never pulls the author's board into the player bundle.
 */
import { legalPresses } from "./progress";
import type { LightsOutDefinition, LightsOutSolution, Press } from "./types";

/** Nothing pressed yet: an empty key, which `validate_solution` refuses on save. */
export function emptySolution(_definition: LightsOutDefinition): LightsOutSolution {
  return { presses: [] };
}

/** Whether a stored value is a press list at all. */
export function isPressList(value: unknown): value is LightsOutSolution {
  if (typeof value !== "object" || value === null || Array.isArray(value)) return false;
  return Array.isArray((value as { presses?: unknown }).presses);
}

/** Reads whatever is stored, however wrong, as the presses this board can play. */
export function pressesOf(value: unknown, definition: LightsOutDefinition): Press[] {
  return isPressList(value) ? legalPresses(definition, value.presses) : [];
}

/** How a key reads in the tape under the board: `R1C1 R2C3 …`, one-based like the labels. */
export function formatPresses(presses: Press[]): string {
  return presses.map(([r, c]) => `R${r + 1}C${c + 1}`).join(" ");
}
